export interface GalleryItems {
  vehicle_id?: string;
  gallery_id: string;
  gallery_name: string;
  gallery_name_arabic: string;
  gallery_placeholder: string | ArrayBuffer | File;
  isImage?: boolean;
}
export interface GalleryPost {
  vehicle_id?: string;
  part_name: string;
  vehicle_gallery_data: string | ArrayBuffer | File;
}
